import { render, staticRenderFns } from "./MetaboliteManage.vue?vue&type=template&id=1b2c1605&scoped=true&"
import script from "./MetaboliteManage.vue?vue&type=script&lang=js&"
export * from "./MetaboliteManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c1605",
  null
  
)

export default component.exports